import Vue from 'vue'
import { N_ERROR, N_SUCCESS } from 'vuex-store/action-types'
import api from '../../api'

const state = {
  sessions: {}
}

const mutations = {
  login (state, data) {
    Vue.set(state.sessions, data.endpoint, {
      authenticated: true,
      scope: data.scope,
      type: data.token_type,
      access_token: data.access_token,
      expires: data.expires,
      rememberMe: data.rememberMe
    })
  },
  logout (state, data) {
    Vue.set(state.sessions, data.endpoint, {
      authenticated: false,
      scope: '',
      type: '',
      access_token: ''
    })
  }
}

const getters = {
  ok: (state, getters, rootState) => {
    let o = state.sessions[rootState.endpoint]
    if (o) {
      return o.authenticated && (Date.now() < o.expires)
    } else {
      return false
    }
  },
  token: (state, getters, rootState) => {
    if (getters.ok) {
      return state.sessions[rootState.endpoint].access_token
    } else {
      return null
    }
  },
  scope: (state, getters, rootState) => {
    if (getters.ok) {
      return state.sessions[rootState.endpoint].scope
    } else {
      return 'not authed'
    }
  }
}

const actions = {
  login ({ commit, dispatch, rootGetters, rootState }, payload) {
    api.call({
      method: 'post',
      baseURL: rootGetters.endpointUrl,
      url: '/oauth2/v1/token',
      data: Object.assign({
        'grant_type': 'password',
        'scope': 'admin support developer reporter'
      }, {
        username: payload.username,
        password: payload.password
      })
    })
    .then((res) => {
      let data = res.data
      data.expires = (data.expires_in * 1000) + Date.now()
      dispatch(N_SUCCESS, 'Login successful', { root: true })
      data.endpoint = rootState.endpoint
      commit('login', data)
      if (payload.callback) {
        payload.callback(res)
      }
    })
    .catch((err) => {
      dispatch(N_ERROR, err.response.data.message, { root: true })
      if (payload.callback) {
        payload.callback(err.response)
      }
    })
  },
  logout ({ commit, rootState }) {
    commit('logout', { endpoint: rootState.endpoint })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./client/store/modules/auth.js